<template>
    <div>
        <h1 id="wellcome">Hola {{name}}, Tus Cursos Son...</h1>
        <el-row v-if="courses != null">
            <el-col :xs="24" :md="10">
            <course-card id="card2" :courseId="courses[0]"></course-card>
            </el-col>
            <el-col :xs="24" :md="10">
            <course-card id="card2" :courseId="courses[1]"></course-card>
            </el-col>
        </el-row>
        <div v-else >
            <div id="no-courses">
                <h1 id="study-plan-title">Por el momento no tiene cursos disponibles</h1>
            </div>
        </div>
         <router-link id="more-courses" :to="{ name: 'myCourses' }">Ver Mas Cursos...</router-link>
    </div>
</template>

<script>
import courseCard from '@/components/wellcome/courseCard';
import { getTrainingByPosition } from '@/requests/trainings'
import axios from 'axios'
import { userAPIRoot } from '@/config/users.config'
export default {
    components: { courseCard },
    data() {
        return {
            name: this.$session.get('name'),
            courses: null,
            loading: false,
        }
    },
    mounted() {
        axios.get(userAPIRoot+'/users/'+this.$session.get('userId')+'/companyUsers')
        .then((respuesta)=>{
            if(respuesta){

                console.log(respuesta.data[0].position)
                for (let i = 0; i < respuesta.data.length; i++) {
                    
                    getTrainingByPosition({ companyId: respuesta.data[i].company, positionId: respuesta.data[i].position})
                    .then((res)=>{
                        // console.log(res.items[0].courses)
                        if(res){
                            this.courses = res.items[0].courses
                        }
                    })
                    
                }
                
            }
             
        })
    }
}
</script>

<style>

    #no-courses {
        margin: 0 auto;
        padding: 100px;
        position: static;
    }

    #wellcome{
        margin: 0px 0px 20px;
        color: #0056A8;
    }

     #more-courses {
        float: right;
        padding-top: 50px;
        padding-right: 30px;
        font-size: 20px;
    }

    #card2{
        margin-left: 40px;
        box-shadow: 0px 2px 10px rgba(162, 166, 163, 0.25);
        border-radius: 12px;
        
    }

    #card-content{
        padding: 14px;
        text-align: center;
        background-color: #F4F4F4;
    }

    .bottom {
        margin-top: 13px;
        line-height: 12px;
    }

    .button {
        padding: 0;
        float: right;
    }

    .card-image {
        max-width: 360px;
        height: 250px;
        display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }
    
    .clearfix:after {
        clear: both
    }

    @media (max-width:767px){
        #card2{
            margin: 15px 0px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/wellcome/wellcome.vue